// Données des produits wellness
export const wellnessProducts = [
  // SAUNAS INTÉRIEURS
  {
    id: "chaleur-s",
    name: "Chaleur S",
    category: "sauna-interieur",
    shortDescription: "Le modèle emblématique d'Alpha Wellness. Sauna intérieur en bois d'ayous aux banquettes ergonomiques avec profils arrondis. Poêle jusqu'à 8kW, éclairage LED RGB et Bluetooth intégré.",
    fullDescription: "La série Chaleur est le tout premier modèle sorti de la table à dessin d'Alpha Wellness Sensations. En 2024, le Chaleur S a bénéficié d'une mise à jour majeure : finition intérieure en bois d'ayous avec profils à 30°, banquettes au nez arrondi coupé à 45°, et panneau de commande intégré à l'intérieur de la cabine pour un confort maximal. Le concept Chaleur sert de base aux produits sur mesure, ajustés à vos souhaits avec des possibilités pratiquement illimitées.",
    standardEquipment: [
      "Finition extérieure en OSB/contreplaqué",
      "Finition intérieure en bois d'ayous 130x13mm",
      "Semelle étanche sur le périmètre du sauna",
      "Plafond suspendu",
      "Banquettes, dossiers, plinthes, grille de protection du poêle en bois d'ayous",
      "Double bande LED blanc chaud derrière les dossiers",
      "Porte vitrée 650x1850 en verre trempé 8mm avec charnières et poignée Luxury",
      "Poêle sauna Alpha Heat noir, 380V",
      "Unité de commande Wave.com4",
      "Tapis antidérapant, appuie-têtes, thermomètre, set sauna"
    ],
    dimensions: [
      { model: "Chaleur S (1-2 pers.)", size: "165 x 125 x 200 cm", power: "4.5 kW" },
      { model: "Chaleur S (3-6 pers.)", size: "220 x 200 x 200 cm", power: "8 kW" },
      { model: "Chaleur S (3-6 pers.)", size: "220 x 220 x 200 cm", power: "8 kW" }
    ],
    images: [
      "https://cdn.easypublisher.be/organizations/1/Products/New Chaleur Sauna/Photos/21.jpg",
      "https://cdn.easypublisher.be/organizations/1/Products/New Chaleur Sauna/Photos/20.jpg",
      "https://cdn.easypublisher.be/organizations/1/Products/New Chaleur Sauna/Photos/19.jpg",
      "https://cdn.easypublisher.be/organizations/1/Products/New Chaleur Sauna/Photos/14.jpg",
      "https://cdn.easypublisher.be/organizations/1/Products/New Chaleur Sauna/Photos/11.jpg",
      "https://cdn.easypublisher.be/organizations/1/Products/New Chaleur Sauna/Photos/DSC01165.jpg",
      "https://cdn.easypublisher.be/organizations/1/Products/New Chaleur Sauna/Photos/DSC00958-Edit_zeqsrw3.jpg"
    ],
    thumbnail: "https://cdn.easypublisher.be/organizations/1/Products/New Chaleur Sauna/Photos/21.jpg"
  },
  {
    id: "chaleur-de-luxe-s",
    name: "Chaleur de Luxe",
    category: "sauna-interieur",
    shortDescription: "Version prestige avec mur en pierre naturelle, ciel étoilé LED (173 points lumineux) et façade en verre clair. Jusqu'à 6 personnes.",
    fullDescription: "Le Chaleur dans sa version la plus luxueuse : banquettes et dossiers exclusifs de série, murs arrière finis en pierres de quartzite beige (Soft Heat) ou bleu (Blue), ciel étoilé avec 173 points lumineux de 3 diamètres différents (2 à 6 mm) et façade vitrée avec charnières en acier inoxydable. Disponible en 4 tailles standard pour 2 à 6 personnes. La température se règle de 30 à 110°C par paliers de 1°C. L'éclairage du ciel étoilé se contrôle par télécommande avec variation d'intensité et choix de couleurs infini.",
    standardEquipment: [
      "Finition intérieure et extérieure en cèdre rouge du Canada, ayous, hemlock ou tremble",
      "Banquettes, dossiers, grille de protection et caillebotis en bois d'ayous",
      "Bandes de pierre naturelle sur le mur arrière (2 types au choix)",
      "Façade vitrée en verre trempé clair 8mm, porte 690mm avec charnières inox",
      "Unité de commande Wave.com4 à l'intérieur du sauna",
      "Poêle sauna Tower Heat",
      "Ciel étoilé LED : 150 points 2mm, 15 points 4mm, 8 points 6mm",
      "Appuie-têtes, thermomètre, set sauna",
      "Enceinte avec connexion Bluetooth"
    ],
    dimensions: [
      { model: "Chaleur de Luxe (2-4 pers.)", size: "200 x 175 x 200 cm", power: "9 kW" },
      { model: "Chaleur de Luxe (3-6 pers.)", size: "220 x 200 x 200 cm", power: "12 kW" },
      { model: "Chaleur de Luxe (3-6 pers. pentagon)", size: "220 x 220 x 200 cm", power: "12 kW" },
      { model: "Chaleur de Luxe (3-6 pers. XL)", size: "250 x 200 x 200 cm", power: "12 kW" }
    ],
    images: [
      "https://cdn.easypublisher.be/organizations/1/Products/Chaleur de luxe 339807 en/Photos/Chaleur_deluxe  Sauna.jpg",
      "https://cdn.easypublisher.be/organizations/1/Products/Chaleur de luxe 339807 en/Photos/IMG_2610-HDR.jpg",
      "https://cdn.easypublisher.be/organizations/1/Products/Chaleur de luxe 339807 en/Photos/IMG_3463.jpg",
      "https://cdn.easypublisher.be/organizations/1/Products/Chaleur de luxe 339807 en/Photos/DSC07250.jpg",
      "https://cdn.easypublisher.be/organizations/1/Products/Chaleur de luxe 339807 en/Photos/DSC05399-Edit.jpg",
      "https://cdn.easypublisher.be/organizations/1/Products/Chaleur de luxe 339807 en/Photos/DSC05529.jpg"
    ],
    thumbnail: "https://cdn.easypublisher.be/organizations/1/Products/Chaleur de luxe 339807 en/Photos/Chaleur_deluxe  Sauna.jpg"
  },
  {
    id: "mirage",
    name: "Mirage",
    category: "sauna-interieur",
    shortDescription: "Design contemporain avec panneaux en placage Fungi et profils 3D verticaux. Façade entièrement vitrée, poêle Huum Drop 9kW.",
    fullDescription: "Le Sauna Mirage incarne l'architecture intérieure contemporaine appliquée au wellness. Sa finition extérieure en lames de thermo-ayous et sa façade entièrement vitrée en font un objet design autant qu'un espace de détente. L'intérieur associe des panneaux en placage Fungi sur les parois latérales, un plafond en placage Chen-Chen avec éclairage indirect, et un mur arrière en ayous 3D vertical. Les banquettes Luxury à deux niveaux en bois d'ayous sont éclairées par des bandes LED RGB au niveau du nez de la marche. Le poêle Huum Drop 9kW et la commande Wave.com4 complètent l'ensemble.",
    standardEquipment: [
      "Finition extérieure en lames de thermo-ayous",
      "Façade vitrée avec porte en verre clair et poignée en D en bois avec charnières Luxury",
      "Panneaux en placage Fungi pour les parois latérales",
      "Plafond en placage Chen-Chen avec éclairage indirect",
      "Mur arrière en ayous 3D vertical",
      "Banquettes Luxury à 2 niveaux en bois d'ayous",
      "Plinthes Luxury en bois d'ayous",
      "Bandes LED RGB au nez de la marche",
      "Dossiers en placage Fungi avec LED RGB haut et bas",
      "Dossiers ergonomiques en ayous sur les parois latérales (40cm de large)",
      "Poêle Huum Drop 9kW, 380V",
      "Unité de commande Wave.com4",
      "Set sauna, thermomètre"
    ],
    dimensions: [
      { model: "Sauna Mirage", size: "220 x 230 x 200 cm", power: "9 kW" }
    ],
    images: [
      "https://cdn.easypublisher.be/organizations/1/Projects/Mirage sauna keerbergen be/Photos/DSC06632.jpg",
      "https://cdn.easypublisher.be/organizations/1/Projects/Sauna chaleur custom gent be/Photos/DSC03546.jpg"
    ],
    thumbnail: "https://cdn.easypublisher.be/organizations/1/Projects/Mirage sauna keerbergen be/Photos/DSC06632.jpg"
  },
  {
    id: "panoramic",
    name: "Panoramic",
    category: "sauna-interieur",
    shortDescription: "Sauna panoramique avec larges baies vitrées pour profiter de la vue tout en se relaxant. Construction sur mesure.",
    fullDescription: "Le sauna Panoramic offre une expérience immersive grâce à ses larges surfaces vitrées qui laissent entrer la lumière naturelle et le paysage dans votre espace wellness. Idéal pour les résidences avec vue, chalets de montagne ou espaces avec un jardin paysager. La construction sur mesure permet d'adapter parfaitement les dimensions et la configuration à votre espace. Disponible avec tous les types de finition intérieure (cèdre, hemlock, ayous) et les équipements standard Alpha Wellness.",
    standardEquipment: [
      "Larges baies vitrées en verre trempé double",
      "Finition intérieure au choix : cèdre rouge, hemlock, ayous",
      "Banquettes ergonomiques en bois d'ayous",
      "Éclairage LED RGB",
      "Poêle sauna adapté à la surface",
      "Unité de commande Wave.com4",
      "Construction sur mesure selon vos plans"
    ],
    dimensions: [
      { model: "Sur mesure", size: "Selon votre projet", power: "Adaptée" }
    ],
    images: [
      "https://cdn.easypublisher.be/organizations/1/Projects/Panoramic sauna hasselt be/Photos/DSC02735.jpg",
      "https://cdn.easypublisher.be/organizations/1/Projects/Panoramic sauna kuringen be/Photos/DSC00409.jpg"
    ],
    thumbnail: "https://cdn.easypublisher.be/organizations/1/Projects/Panoramic sauna hasselt be/Photos/DSC02735.jpg"
  },
  
  // SAUNAS EXTÉRIEURS
  {
    id: "chaleur-outdoor",
    name: "Chaleur Outdoor",
    category: "sauna-exterieur",
    shortDescription: "Sauna extérieur en thermo-ayous résistant aux intempéries. Disponible en sauna, infrarouge, bio-sauna ou combiné.",
    fullDescription: "Profitez du wellness en plein air, quelle que soit la météo. Le Chaleur Outdoor est un produit unique où vous pouvez vous détendre tout en profitant de la vie en extérieur. Il vous permet de vivre pleinement l'hiver comme l'été, avec une connexion intense avec la nature. Le Chaleur Outdoor existe en version sauna, infrarouge, bio-sauna, ou une combinaison de ces 3 thérapies. Sa finition extérieure en bois de thermo-ayous traité thermiquement, avec membrane EPDM sur le toit, gouttières et descentes, garantit une durabilité optimale.",
    standardEquipment: [
      "Finition extérieure en bois de thermo-ayous traité, membrane EPDM sur le toit",
      "Gouttières et descentes d'eau",
      "Finition intérieure au choix : cèdre rouge du Canada, hemlock, ayous, tremble ou pin",
      "Banquettes en bois d'ayous",
      "Porte vitrée en verre de sécurité teinté",
      "Éclairage LED RGB",
      "Enceinte Bluetooth",
      "Poêle sauna adapté"
    ],
    dimensions: [
      { model: "Chaleur Outdoor", size: "Sur mesure", power: "Adaptée" }
    ],
    images: [
      "https://cdn.easypublisher.be/organizations/1/Projects/Outdoor wellness grez doiceau be/Photos/DSC07541.jpg",
      "https://cdn.easypublisher.be/organizations/1/Projects/Chaleur outdoor profondeville/Photos/DSC00947.jpg",
      "https://cdn.easypublisher.be/organizations/1/Projects/Chaleur outdoor valais ch/Photos/DJI_0229.jpg"
    ],
    thumbnail: "https://cdn.easypublisher.be/organizations/1/Projects/Outdoor wellness grez doiceau be/Photos/DSC07541.jpg"
  },
  {
    id: "chaleur-combi",
    name: "Chaleur Combi",
    category: "sauna-exterieur",
    shortDescription: "Sauna + infrarouge dans une même cabine extérieure. Le meilleur des deux mondes, utilisable en toutes saisons.",
    fullDescription: "Le Chaleur Combi est une cabine extérieure qui combine la technologie sauna traditionnelle et infrarouge pour profiter du wellness en toutes saisons. En plus des émetteurs infrarouges, un poêle sauna maintient l'air chaud pendant les périodes froides. Vous pouvez choisir entre des émetteurs Duo, magnésium ou quartz, facilement contrôlables par l'unité de commande à intensité variable. La finition extérieure en pin scandinave avec profils à recouvrement offre un aspect naturel et robuste.",
    standardEquipment: [
      "Finition extérieure en pin scandinave, profils à recouvrement non traités",
      "Finition intérieure au choix : cèdre rouge, hemlock, ayous, tremble ou pin",
      "Banquettes en bois d'ayous",
      "Émetteurs infrarouges DUO, magnésium ou quartz (au choix)",
      "Poêle sauna pour les périodes froides",
      "Unité de commande à intensité variable",
      "Éclairage LED RGB",
      "Enceinte Bluetooth"
    ],
    dimensions: [
      { model: "Chaleur Combi", size: "Sur mesure", power: "Adaptée" }
    ],
    images: [
      "https://cdn.easypublisher.be/organizations/1/Projects/Sauna chaleur combi edegem be/Photos/vandemierop-narrare-94.jpg",
      "https://cdn.easypublisher.be/organizations/1/Projects/Outdoor chaleur combi sauna genk be/Photos/IMG_9957-Edit.jpg",
      "https://cdn.easypublisher.be/organizations/1/Projects/Chaleur combi sauna zonhoven be/Photos/DSC02695.jpg"
    ],
    thumbnail: "https://cdn.easypublisher.be/organizations/1/Projects/Sauna chaleur combi edegem be/Photos/vandemierop-narrare-94.jpg"
  },
  {
    id: "eclipse",
    name: "Eclipse",
    category: "sauna-exterieur",
    shortDescription: "Design cylindrique iconique. Diamètres de 250 à 360 cm. Disponible en sauna, hammam ou infrarouge.",
    fullDescription: "L'Eclipse au design cylindrique est sans aucun doute la cabine extérieure la plus spectaculaire du marché, avec des diamètres de 250 à 360 cm. Disponible en version sauna, hammam ou infrarouge, avec vestiaire et salle de détente en options. Le design rond élimine les coins morts, offrant une distribution optimale de la chaleur. La structure est construite autour d'un cadre métallique entièrement isolé. L'extérieur est fini en EPDM et bruyère de série, avec options d'enduit ou d'habillage en acier Corten. L'intérieur en hemlock, cèdre ou ayous est sublimé par un mur arrière en pierres de sel de l'Himalaya.",
    standardEquipment: [
      "Finition extérieure en bruyère sur membrane EPDM",
      "Structure métallique entièrement isolée",
      "Finition intérieure en thermo-ayous 40x11mm",
      "Sol en carrelage aspect bois",
      "Mur arrière en briques de sel brut",
      "Banquettes et dossiers en thermo-ayous",
      "Façade vitrée en double verre trempé clair avec porte aluminium",
      "Unité de commande Wave.com4 intérieure",
      "Poêle Drop 9kW, 380V",
      "Bandes LED RGB derrière les dossiers et sous les banquettes avec télécommande",
      "Appuie-têtes, set sauna",
      "Enceinte Premium Lithe avec Bluetooth"
    ],
    dimensions: [
      { model: "Eclipse S", size: "250 x 360 x 230 cm (diamètre 250-360)", power: "9 kW" }
    ],
    images: [
      "https://cdn.easypublisher.be/organizations/1/Projects/Eclipse asten nl/Photos/DSC05392.jpg",
      "https://cdn.easypublisher.be/organizations/1/Projects/Chaleur outdoor sauna eischen lu/Photos/DSC08625-Edit.jpg",
      "https://cdn.easypublisher.be/organizations/1/Projects/Chaleur outdoor valais ch/Photos/DJI_0229.jpg"
    ],
    thumbnail: "https://cdn.easypublisher.be/organizations/1/Projects/Eclipse asten nl/Photos/DSC05392.jpg"
  },
  {
    id: "eclipse-xl",
    name: "Eclipse XL",
    category: "sauna-exterieur",
    shortDescription: "Version grand format pour jusqu'à 18 personnes. Idéal pour hôtels, spas et résidences de prestige.",
    fullDescription: "L'Eclipse XL est le sauna extérieur grand format parfait pour des groupes jusqu'à 18 personnes, grâce à ses dimensions de 350 x 480 x 266 cm. La structure est construite autour d'un cadre métallique renforcé entièrement isolé. L'intérieur offre des profils en hemlock, cèdre ou ayous avec des banquettes Wave en bois d'ayous. Le mur arrière est recouvert de pierres de sel de l'Himalaya. Un vestiaire est disponible en option. Idéal pour les hôtels, centres de spa, domaines de vacances ou grandes propriétés privées.",
    standardEquipment: [
      "Finition extérieure en bruyère sur membrane EPDM",
      "Structure métallique renforcée et isolée",
      "Finition intérieure en cèdre rouge, hemlock ou ayous",
      "Banquettes Wave en bois d'ayous",
      "Pierres de sel de l'Himalaya sur le mur arrière",
      "Façade vitrée en double verre trempé",
      "LED RGB sur le cercle, derrière les dossiers et sous les banquettes",
      "Poêle sauna haute puissance",
      "Vestiaire en option"
    ],
    dimensions: [
      { model: "Eclipse XL (jusqu'à 18 pers.)", size: "350 x 480 x 266 cm", power: "Haute puissance" }
    ],
    images: [
      "https://cdn.easypublisher.be/organizations/1/Projects/Outdoor sauna house munster de/Photos/DSC06658.jpg",
      "https://cdn.easypublisher.be/organizations/1/Projects/Aqua stadium tourcoing les bains fr/Photos/DSC08935.jpg"
    ],
    thumbnail: "https://cdn.easypublisher.be/organizations/1/Projects/Outdoor sauna house munster de/Photos/DSC06658.jpg"
  },
  {
    id: "noa-outdoor",
    name: "NOA Outdoor Living",
    category: "sauna-exterieur",
    shortDescription: "Concept outdoor complet : sauna, espace détente et vestiaire dans un design architectural minimaliste.",
    fullDescription: "Le NOA Outdoor Living est un concept complet d'espace wellness extérieur qui intègre sauna, zone de détente et vestiaire dans un design architectural minimaliste et contemporain. Conçu comme un véritable pavillon de jardin, il s'intègre harmonieusement dans tout environnement paysager. Les matériaux nobles et les finitions haut de gamme en font la référence pour les espaces extérieurs de prestige.",
    standardEquipment: [
      "Structure architecturale complète",
      "Sauna intégré avec équipement complet",
      "Espace détente",
      "Vestiaire",
      "Finitions haut de gamme",
      "Éclairage LED intégré",
      "Construction sur mesure"
    ],
    dimensions: [
      { model: "NOA Outdoor Living", size: "Sur mesure", power: "Adaptée" }
    ],
    images: [
      "https://cdn.easypublisher.be/organizations/1/Projects/Noa outdoor living kruisem be/Photos/DSC00179.jpg"
    ],
    thumbnail: "https://cdn.easypublisher.be/organizations/1/Projects/Noa outdoor living kruisem be/Photos/DSC00179.jpg"
  },
  
  // CABINES INFRAROUGES
  {
    id: "chaleur-ir",
    name: "Chaleur IR",
    category: "infrarouge",
    shortDescription: "La cabine infrarouge de référence. 5 tailles standard, jusqu'à 6 personnes. Émetteurs quartz, magnésium ou DUO.",
    fullDescription: "L'infrarouge Chaleur est un développement révolutionnaire qui a secoué les fondations de l'industrie du wellness et reste, à ce jour, un leader en termes de qualité et de sécurité. Cette cabine infrarouge confortable est disponible en 5 tailles standard pour jusqu'à 6 personnes. La finition extérieure est en pin scandinave, avec plusieurs options pour l'intérieur : cèdre rouge du Canada, hemlock, ayous, tremble ou pin. Vous choisissez le type d'émetteurs : magnésium, quartz ou DUO. L'unité de commande moderne permet d'ajuster l'intensité des émetteurs arrière et avant, tandis que le chauffage au sol et des pieds peut être activé ou désactivé. En préréglant la température, la cabine maintient une température stable pendant la séance.",
    standardEquipment: [
      "Finition extérieure en pin scandinave",
      "Finition intérieure au choix : cèdre rouge, hemlock, ayous, tremble ou pin",
      "Banquettes en bois d'ayous",
      "Porte vitrée teintée de sécurité 1770x590x8mm avec charnières et poignée",
      "Unité de commande Alpha à intensité variable",
      "Émetteurs DUO, magnésium ou quartz + chauffage au sol",
      "Éclairage LED RGB avec cadre en bois",
      "Connexion Bluetooth avec 1 enceinte"
    ],
    dimensions: [
      { model: "Chaleur IR (1 pers.)", size: "100 x 105 x 200 cm", power: "IR" },
      { model: "Chaleur IR (1-2 pers.)", size: "130 x 105 x 200 cm", power: "IR" },
      { model: "Chaleur IR (2-3 pers.)", size: "155 x 115 x 200 cm", power: "IR" },
      { model: "Chaleur IR (2-4 pers.)", size: "175 x 130 x 200 cm", power: "IR" },
      { model: "Chaleur IR (4-6 pers.)", size: "210 x 160 x 200 cm", power: "IR" }
    ],
    images: [
      "https://cdn.easypublisher.be/organizations/1/Projects/Sauna infrared mont lambert fr/Photos/DSC04774.jpg",
      "https://cdn.easypublisher.be/organizations/1/Projects/Private wellness genk be/Photos/DSC06008-2.jpg"
    ],
    thumbnail: "https://cdn.easypublisher.be/organizations/1/Projects/Sauna infrared mont lambert fr/Photos/DSC04774.jpg"
  },
  {
    id: "chaleur-de-luxe-ir",
    name: "Chaleur de Luxe IR",
    category: "infrarouge",
    shortDescription: "Version prestige avec mur en pierre naturelle, ciel étoilé LED et émetteurs rotatifs frontaux.",
    fullDescription: "Le wellness c'est un équilibre sain entre le corps et l'esprit. L'atmosphère de l'espace dans lequel vous vous trouvez vous procure un sentiment de bien-être défini. Pour ce design, Alpha Wellness s'est inspiré du design d'intérieur contemporain et des matériaux nobles. Le résultat : un sauna infrarouge élégant avec émetteurs dorsaux, pour les jambes et rotatifs frontaux pour un bénéfice maximal de la chaleur infrarouge. L'intérieur luxueux est visible à travers la porte en verre clair : banquettes en bois d'ayous, panneaux latéraux en cèdre ou hemlock, mur arrière en pierre naturelle et ciel étoilé LED avec enceintes intégrées.",
    standardEquipment: [
      "Finition intérieure et extérieure en cèdre rouge, hemlock, ayous ou tremble",
      "Bandes de pierre naturelle sur le mur arrière (2 types au choix)",
      "Banquettes, dossiers ergonomiques, sol en bois d'ayous",
      "Façade vitrée de sécurité avec porte 1790x691x8mm, charnières et poignée inox",
      "Unité de commande Alpha à intensité variable",
      "Émetteurs infrarouges quartz, chauffage au sol + émetteurs rotatifs frontaux",
      "Ciel étoilé LED : 75 points 2mm, 8 points 6mm",
      "Connexion Bluetooth avec 1 enceinte"
    ],
    dimensions: [
      { model: "Chaleur de Luxe IR (1-2 pers.)", size: "130 x 105 x 200 cm", power: "IR" },
      { model: "Chaleur de Luxe IR (2-3 pers.)", size: "155 x 120 x 200 cm", power: "IR" },
      { model: "Chaleur de Luxe IR (3-4 pers.)", size: "175 x 130 x 200 cm", power: "IR" },
      { model: "Chaleur de Luxe IR (3 pers. pentagon)", size: "145 x 145 x 200 cm", power: "IR" }
    ],
    images: [
      "https://cdn.easypublisher.be/organizations/1/Projects/Private wellness genk be/Photos/DSC06008-2.jpg",
      "https://cdn.easypublisher.be/organizations/1/Projects/Private wellness lille fr/Photos/DSC09224.jpg"
    ],
    thumbnail: "https://cdn.easypublisher.be/organizations/1/Projects/Private wellness genk be/Photos/DSC06008-2.jpg"
  },
  {
    id: "chaleur-lounge-ir",
    name: "Chaleur Lounge IR",
    category: "infrarouge",
    shortDescription: "Banquette ergonomique en S avec émetteurs infrarouges intégrés. Revêtement cuir. Red Dot Design Award 2017.",
    fullDescription: "Les émetteurs infrarouges ergonomiques brevetés, intégrés dans la banquette, épousent parfaitement les contours du corps. Les émetteurs plein spectre en forme de S fournissent une chaleur pénétrante là où elle est nécessaire. Il vous suffit de vous installer et de vous détendre pendant que la chaleur favorise votre circulation sanguine, soulage les tensions musculaires et réduit les douleurs articulaires. Des émetteurs sont également prévus sur les côtés. La banquette est recouverte d'imitation cuir autour des émetteurs dorsaux pour un confort d'assise optimal. Chauffage au sol, système audio Bluetooth et unité de commande moderne complètent l'ensemble. Lauréat du Red Dot Design Award 2017 et du Wellness Innovation Award 2018.",
    standardEquipment: [
      "Finition au choix : pin scandinave, cèdre rouge, hemlock, tremble, ayous ou combinaison",
      "Façade en verre de sécurité",
      "Banquette ergonomique avec revêtement imitation cuir",
      "Émetteurs quartz front et côtés + émetteurs ergonomiques dorsaux en forme de S",
      "Chauffage au sol",
      "Système audio avec 1 enceinte et Bluetooth",
      "Unité de commande moderne à intensité variable",
      "Options : appuie-têtes cuir, repose-pieds, liseuse"
    ],
    dimensions: [
      { model: "Chaleur Lounge IR", size: "Sur mesure", power: "IR" }
    ],
    images: [
      "https://cdn.easypublisher.be/organizations/1/Projects/Chaleur lounge antwerpen be/Photos/DSC09489.jpg",
      "https://cdn.easypublisher.be/organizations/1/Projects/Chaleur lounge moerzeke be/Photos/DSC09691.jpg"
    ],
    thumbnail: "https://cdn.easypublisher.be/organizations/1/Projects/Chaleur lounge antwerpen be/Photos/DSC09489.jpg"
  },
  {
    id: "chaleur-lounge-elt",
    name: "Chaleur Lounge ELT",
    category: "infrarouge",
    shortDescription: "Infrarouge + luminothérapie ELT. Stimule la production de collagène. Détente et soin de la peau en une séance.",
    fullDescription: "Le Chaleur Lounge ELT est la seule cabine wellness qui combine la technologie infrarouge avec une thérapie basée sur la production de collagène : l'Energizing Light Technology (ELT). La lumière de différents spectres actifs pénètre profondément dans la peau et stimule la production naturelle de collagène du corps sur le visage, le cou et le haut du tronc. Ce mélange de deux spectres lumineux assure une peau veloutée et un teint éclatant. Le tout pendant une séance de relaxation infrarouge pour se détoxifier et se détendre. Design breveté, ergonomie inégalée et couverture complète de la colonne cervicale au coccyx grâce à l'émetteur de 100 cm.",
    standardEquipment: [
      "Finition extérieure en pin scandinave",
      "Finition intérieure au choix : cèdre rouge, hemlock, ayous, tremble ou pin",
      "Banquette ergonomique en cèdre rouge avec revêtement imitation cuir",
      "Émetteurs infrarouges plein spectre en forme de S (brevetés)",
      "Technologie ELT (Energizing Light Technology) intégrée",
      "Chauffage au sol",
      "Unité de commande Alpha à intensité variable",
      "Design breveté, lauréat du Wellness & Spa Innovation Award"
    ],
    dimensions: [
      { model: "Chaleur Lounge ELT", size: "Sur mesure", power: "IR + ELT" }
    ],
    images: [
      "https://cdn.easypublisher.be/organizations/1/Projects/Chaleur lounge moerzeke be/Photos/DSC09691.jpg",
      "https://cdn.easypublisher.be/organizations/1/Projects/Chaleur lounge antwerpen be/Photos/DSC09489.jpg"
    ],
    thumbnail: "https://cdn.easypublisher.be/organizations/1/Projects/Chaleur lounge moerzeke be/Photos/DSC09691.jpg"
  }
];

// Catégories disponibles
export const wellnessCategories = [
  { id: 'all', label: 'Tous les produits' },
  { id: 'sauna-interieur', label: 'Saunas intérieurs' },
  { id: 'sauna-exterieur', label: 'Saunas extérieurs' },
  { id: 'infrarouge', label: 'Cabines infrarouges' }
];
